import { spacing, styled } from "../../../stitches.config";

export const List = styled("ul", {
  display: "flex",
  flexDirection: "column",
  listStyleType: "none",
  paddingLeft: "0",
  margin: "0",
  gap: spacing.l,
});

export const ActivityDateGroup = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: spacing.m,
  paddingBottom: spacing.l,
});
